import i18n from "../../../../constants/i18n";
import { CSR_MY_CSR_EFFECTIVENESS_HEADERS } from "../../../../constants/table-custom-headers/CSR";
import getMyCSRPerformanceStore from "../../../../stores/csr-store/csr-performance";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const EffectivenessTableData = withLiteObserverAndTheme(() => {
  return (
    <Et3Table
      columns={CSR_MY_CSR_EFFECTIVENESS_HEADERS}
      rows={getMyCSRPerformanceStore().effectivenessDataOrdered.get()}
      title={i18n.get("EFFECTIVENESS")}
      shouldBeFlagged={false}
      titleKey={"EFFECTIVENESS"}
    />
  );
});
export default EffectivenessTableData;
